import { translate } from 'react-switch-lang';
import { FormGroup } from 'reactstrap';

const DetailDevise = (props) => {
  return (
    <form className="needs-validation" noValidate>
      <FormGroup className="form-row">
        <label>{props.t('devise_name')}</label>
        <input type="text" className="form-control" name="name" value={props.devise.name} disabled />
      </FormGroup>
      <FormGroup className="form-row">
        <label>{props.t('devise_code')}</label>
        <input type="text" className="form-control" name="value" value={props.devise.code} disabled />
      </FormGroup>
    </form>
  );
};

export default translate(DetailDevise);
